import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ConfirmProvider } from "@/components/ConfirmProvider";
import { Layout } from "@/components/layout/Layout";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { Toaster } from "@/components/ui/sonner";
import Landing from "@/pages/Landing";
import Jobs from "@/pages/Jobs";
import JobDetail from "@/pages/JobDetail";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import VerifyEmail from "@/pages/VerifyEmail";
import Help from "@/pages/Help";
import Privacy from "@/pages/Privacy";
import Terms from "@/pages/Terms";
import DataDeletion from "@/pages/DataDeletion";
import Dashboard from "@/pages/Dashboard";
import Applications from "@/pages/candidate/Applications";
import Saved from "@/pages/candidate/Saved";
import Profile from "@/pages/candidate/Profile";
import JobRequest from "@/pages/candidate/JobRequest";
import EmployerOverview from "@/pages/employer/Overview";
import Restaurants from "@/pages/employer/Restaurants";
import EmployerJobs from "@/pages/employer/Jobs";
import EmployerApplications from "@/pages/employer/Applications";
import EmployerCandidates from "@/pages/employer/Candidates";
import EmployerNotifications from "@/pages/employer/Notifications";
import EmployerPlans from "@/pages/employer/Plans";
import EmployerBilling from "@/pages/employer/Billing";
import EmployerAccount from "@/pages/employer/Account";
import AdminOverview from "@/pages/admin/Overview";
import AdminUsers from "@/pages/admin/Users";
import AdminJobs from "@/pages/admin/Jobs";
import AdminReceipts from "@/pages/admin/Receipts";
import AdminAccount from "@/pages/admin/Account";
import AdminDeletionRequests from "@/pages/admin/DeletionRequests";
import AdminAds from "@/pages/admin/Ads";
import AdminSubadmins from "@/pages/admin/Subadmins";

function App() {
  return (
    <AuthProvider>
      <ConfirmProvider>
        <BrowserRouter>
        <Routes>
          <Route element={<Layout />}>
            <Route path="/" element={<Landing />} />
            <Route path="/jobs" element={<Jobs />} />
            <Route path="/jobs/:id" element={<JobDetail />} />
            <Route path="/help" element={<Help />} />
            <Route path="/privacy" element={<Privacy />} />
            <Route path="/terms" element={<Terms />} />
            <Route path="/data-deletion" element={<DataDeletion />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
            <Route
              path="/dashboard"
              element={
                <ProtectedRoute>
                  <Dashboard />
                </ProtectedRoute>
              }
            />
            <Route path="/candidate/applications" element={<ProtectedRoute roles={["candidate"]}><Applications /></ProtectedRoute>} />
            <Route path="/candidate/saved" element={<ProtectedRoute roles={["candidate"]}><Saved /></ProtectedRoute>} />
            <Route path="/candidate/request" element={<ProtectedRoute roles={["candidate"]}><JobRequest /></ProtectedRoute>} />
            <Route path="/candidate/profile" element={<ProtectedRoute roles={["candidate"]}><Profile /></ProtectedRoute>} />

            <Route path="/employer" element={<ProtectedRoute roles={["employer"]}><EmployerOverview /></ProtectedRoute>} />
            <Route path="/employer/restaurants" element={<ProtectedRoute roles={["employer"]}><Restaurants /></ProtectedRoute>} />
            <Route path="/employer/jobs" element={<ProtectedRoute roles={["employer"]}><EmployerJobs /></ProtectedRoute>} />
            <Route path="/employer/applications" element={<ProtectedRoute roles={["employer"]}><EmployerApplications /></ProtectedRoute>} />
            <Route path="/employer/candidates" element={<ProtectedRoute roles={["employer"]}><EmployerCandidates /></ProtectedRoute>} />
            <Route path="/employer/notifications" element={<ProtectedRoute roles={["employer"]}><EmployerNotifications /></ProtectedRoute>} />
            <Route path="/employer/plans" element={<ProtectedRoute roles={["employer"]}><EmployerPlans /></ProtectedRoute>} />
            <Route path="/employer/billing" element={<ProtectedRoute roles={["employer"]}><EmployerBilling /></ProtectedRoute>} />
            <Route path="/employer/account" element={<ProtectedRoute roles={["employer"]}><EmployerAccount /></ProtectedRoute>} />

            <Route path="/admin" element={<ProtectedRoute roles={["admin", "subadmin"]}><AdminOverview /></ProtectedRoute>} />
            <Route path="/admin/users" element={<ProtectedRoute roles={["admin", "subadmin"]}><AdminUsers /></ProtectedRoute>} />
            <Route path="/admin/jobs" element={<ProtectedRoute roles={["admin", "subadmin"]}><AdminJobs /></ProtectedRoute>} />
            <Route path="/admin/receipts" element={<ProtectedRoute roles={["admin", "subadmin"]}><AdminReceipts /></ProtectedRoute>} />
            <Route path="/admin/account" element={<ProtectedRoute roles={["admin", "subadmin"]}><AdminAccount /></ProtectedRoute>} />
            <Route path="/admin/deletion-requests" element={<ProtectedRoute roles={["admin", "subadmin"]}><AdminDeletionRequests /></ProtectedRoute>} />
            <Route path="/admin/ads" element={<ProtectedRoute roles={["admin", "subadmin"]}><AdminAds /></ProtectedRoute>} />
            <Route path="/admin/subadmins" element={<ProtectedRoute roles={["admin", "subadmin"]}><AdminSubadmins /></ProtectedRoute>} />

            <Route path="*" element={<Landing />} />
          </Route>
        </Routes>
        </BrowserRouter>
      </ConfirmProvider>
      <Toaster position="top-center" richColors />
    </AuthProvider>
  );
}

export default App;
